module.exports = __webpack_public_path__ + "img/MTABAPPPWV.340689c1.jpg";